<div class="cardform">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="cpfForm" (ngSubmit)="onSearch()">
        <div class="step-content">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Digite o CPF do voluntário</mat-label>
            <input matInput formControlName="cpf" placeholder="Digite o CPF do voluntário">
            <button matSuffix mat-icon-button type="submit" [disabled]="cpfForm.invalid || isLoading" aria-label="Buscar voluntário">
              <mat-icon *ngIf="!isLoading">search</mat-icon>
              <mat-icon *ngIf="isLoading" class="spin">autorenew</mat-icon>
            </button>
          </mat-form-field>

          <div *ngIf="error" class="alert-error">{{ error }}</div>
          <div *ngIf="!cpfForm.value.cpf" class="alert-info">Digite o CPF do voluntário para continuar</div>

          <div class="step-content volunteer-step-flex">
            <!-- Card do Voluntário -->
            <div *ngIf="volunteer && !error" class="volunteer-card" (click)="onSelect()">
              <h3>Dados do Voluntário</h3>
              <div class="volunteer-info">
                <!-- <p><strong>Nome Completo:</strong> {{volunteer.nomeCompleto}}</p>
                <p><strong>CPF:</strong> {{volunteer.cpf}}</p>
                <p><strong>Número Sistema:</strong> {{volunteer.numeroSistema}}</p> -->
                <p><strong>Nome Colete:</strong> {{volunteer.nomeColete}}</p>
                <p><strong>Comando Regional:</strong> {{volunteer.comandoRegional}}</p>
                <p><strong>Regional:</strong> {{volunteer.regional}}</p>
                <p><strong>Divisão:</strong> {{volunteer.divisao}}</p>
                <p><strong>Cargo:</strong> {{volunteer.cargo}}</p>
                <p><strong>Telefone:</strong> {{volunteer.telefoneCelular}}
                <a *ngIf="volunteer.telefoneCelular"
                [href]="getWhatsappLink(volunteer.telefoneCelular)"
                target="_blank"
                rel="noopener"
                class="whatsapp-link"
                title="Enviar mensagem no WhatsApp">
                <img src="/assets/images/WhatsApp.png" alt="WhatsApp" style="height: 22px; vertical-align: middle;" />
              </a>
              </p>
              <p><strong>Programado para:</strong> {{volunteer.staff?.startAt ? (volunteer.staff?.startAt | date:'dd/MM/yyyy HH:mm') : '-'}}</p>
              </div>
              <div class="card-action">
                <mat-icon>check_circle</mat-icon>
                <span>Clique para selecionar</span>
              </div>
            </div>

            <div *ngIf="success" class="alert-success">{{ success }}</div>

            <!-- Card de Staff se houver -->
            <div *ngIf="volunteer?.staff" class="staff-card">
              <h3>Atuação Atual</h3>
              <div class="staff-info">
                <p><strong>Evento:</strong> {{volunteer?.staff?.currentEvent?.description || '-'}}</p>
                <p><strong>Tipo de Evento:</strong> {{volunteer?.staff?.currentEvent?.eventType?.name || '-'}}</p>
                <p><strong>Job:</strong> {{volunteer?.staff?.job?.description || '-'}}</p>
                <p><strong>Descrição:</strong> {{volunteer?.staff?.location?.description || '-'}}</p>
                <p><strong>Nome do Local:</strong> {{volunteer?.staff?.location?.name || '-'}}</p>
                <p><strong>Início:</strong> {{volunteer?.staff?.startAt ? (volunteer?.staff?.startAt | date:'dd/MM/yyyy HH:mm') : '-'}}</p>
                <p><strong>Telefone:</strong> {{volunteer?.telefoneCelular || '-'}}

                </p>
              </div>
              <div class="card-action-staff">
                <mat-icon color="primary">info</mat-icon>
                <span>Voluntário já está em um job</span>
              </div>

              <!-- Agendado: opções de início -->
              <div *ngIf="isAgendado" class="agendado-actions">
                <button mat-raised-button color="primary" type="button"
                        (click)="iniciarNoLocalDefinido()">
                  <mat-icon>play_arrow</mat-icon>
                  Iniciar no local definido
                </button>
                <button mat-raised-button color="primary" type="button"
                        (click)="iniciarNoLocalUsuarioLogado()">
                  <mat-icon>my_location</mat-icon>
                  Iniciar no meu local
                </button>
                <button mat-stroked-button color="primary" type="button"
                        (click)="onSelect()">
                  <mat-icon>alt_route</mat-icon>
                  Escolher outro local
                </button>
              </div>

              <!-- Demais casos: checkout -->
              <button *ngIf="!isAgendado" mat-raised-button color="warn" type="button" (click)="performCheckout()"
                      class="checkout-button">
                <mat-icon>logout</mat-icon>
                Realizar Checkout
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
